import { dateMask } from './dateMask';
import { dateRangeMask } from './dateRangeMask';
import { numberMask } from './numberMask';
import { phoneMask } from './phoneMask';
import { priceMask } from './priceMask';
import { textMask } from './textMask';
import { timeMask } from './timeMask';

export const Mask = {
  time: timeMask,
  text: textMask,
  number: numberMask,
  phone: phoneMask,
  password: textMask,
  date: dateMask,
  dateRange: dateRangeMask,
  price: priceMask,
};

export type MaskType = keyof typeof Mask;
